/* TVP add to cart — one behaviour for every "Add to cart" on the site. Test theme 2026-09-07.
   The reg-lookup listing already did this well (button turns green, the part flies into the
   basket icon, the count bumps); the product page, the collection/search list cards and the
   recently-viewed cards each did something different. This catches every <form action="/cart/add">
   submit before the theme's own handlers (capture phase), posts it with fetch, and celebrates the
   same way everywhere. The listing keeps its own code and shares the effect via window.tvpAtc.
   Forms marked data-tvp-atc-skip are left alone. */
(function () {
  if (!window.fetch || !window.FormData) return;

  var GREEN = '#289105', RESET_MS = 2500;

  function style() {
    if (document.getElementById('tvp-atc-style')) return;
    var st = document.createElement('style');
    st.id = 'tvp-atc-style';
    st.textContent =
      'html body .tvp-atc-added,html body .tvp-atc-added:hover,html body .tvp-atc-added:focus,html body .tvp-atc-added:active,html body .btn.tvp-atc-added:hover{background:' + GREEN + '!important;background-color:' + GREEN + '!important;border-color:' + GREEN + '!important;color:#fff!important;opacity:1!important;background-image:none!important}' +
      'html body .tvp-atc-error,html body .tvp-atc-error:hover{background:#333!important;background-color:#333!important;border-color:#333!important;color:#fff!important}' +
      '.tvp-atc-fly{position:fixed;z-index:2147483000;pointer-events:none;border-radius:8px;overflow:hidden;background:#fff;' +
        'box-shadow:0 4px 20px rgba(0,0,0,.3);transition:left .7s cubic-bezier(.2,1,.3,1),top .7s cubic-bezier(.2,1,.3,1),' +
        'width .7s cubic-bezier(.2,1,.3,1),height .7s cubic-bezier(.2,1,.3,1),opacity .7s}' +
      '.tvp-atc-fly img{width:100%;height:100%;object-fit:contain;display:block}' +
      '.tvp-atc-bump{transform:scale(1.4)!important;transition:transform .3s!important}' +
      '@media (prefers-reduced-motion:reduce){.tvp-atc-fly{transition:none;display:none}}';
    document.head.appendChild(st);
  }

  function cartIcon() {
    var cands = document.querySelectorAll('.site-header__cart, a[href="/cart"], a[href^="/cart?"], a[href$="/cart"]');
    for (var i = 0; i < cands.length; i++) {
      var r = cands[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return cands[i];   // the first one actually on screen
    }
    return cands[0] || null;
  }

  function onScreen(r) { return r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth; }
  function visibleImg(root, anyPosition) {
    if (!root) return null;
    var imgs = root.querySelectorAll('img'), best = null, area = 0;
    for (var i = 0; i < imgs.length; i++) {
      var r = imgs[i].getBoundingClientRect();
      var a = r.width * r.height;
      if (a > area && (anyPosition || onScreen(r)) && (imgs[i].currentSrc || imgs[i].src)) { best = imgs[i]; area = a; }
    }
    return best;
  }

  function imageFor(form) {
    // A card (listing, collection list, search, recently viewed) carries its own image;
    // the product page's form is separate from the gallery, so fall back to that.
    var card = form.closest('.v2p-card, .list-view-item, .grid__item, .product-card, .product, .featured-product');
    return visibleImg(card) || visibleImg(document.querySelector('.productdetailsslider'), true) || null;
  }

  function fly(img, fromEl) {
    var target = cartIcon();
    if (!img || !target) return;
    var a = img.getBoundingClientRect(), b = target.getBoundingClientRect();
    if (!a.width || !a.height) return;
    var w = Math.min(a.width, 100), h = Math.min(a.height, 100), left = a.left, top = a.top;
    if (!onScreen(a) && fromEl) {
      // On a phone the gallery has usually scrolled away by the time the button is
      // tapped, so the thumbnail sets off from the button instead of from nowhere.
      var f = fromEl.getBoundingClientRect();
      w = h = 64; left = f.left + f.width / 2 - 32; top = f.top + f.height / 2 - 32;
    }
    var el = document.createElement('div');
    el.className = 'tvp-atc-fly';
    el.style.left = left + 'px'; el.style.top = top + 'px';
    el.style.width = w + 'px'; el.style.height = h + 'px';
    var im = document.createElement('img');
    im.src = img.currentSrc || img.src; im.alt = '';
    el.appendChild(im);
    document.body.appendChild(el);
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      el.style.left = (b.left + b.width / 2 - 12) + 'px'; el.style.top = (b.top + b.height / 2 - 12) + 'px';
      el.style.width = '24px'; el.style.height = '24px'; el.style.opacity = '0.2';
    }); });
    setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 800);
    setTimeout(function () {
      target.classList.add('tvp-atc-bump');
      setTimeout(function () { target.classList.remove('tvp-atc-bump'); }, 400);
    }, 550);
  }

  function refreshCount() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var n = c.item_count;
      var els = document.querySelectorAll('[data-cart-count]');
      for (var i = 0; i < els.length; i++) els[i].textContent = n;
      var bubbles = document.querySelectorAll('[data-cart-count-bubble], #CartCount');
      for (var j = 0; j < bubbles.length; j++) bubbles[j].classList.remove('hide');
      return c;
    }).catch(function () { });
  }

  function textNode(btn) { return btn.querySelector('[data-add-to-cart-text]') || btn; }
  function getText(btn) { return btn.tagName === 'INPUT' ? btn.value : textNode(btn).innerHTML; }
  function setText(btn, t) { if (btn.tagName === 'INPUT') btn.value = t.replace(/<[^>]+>/g, ''); else textNode(btn).innerHTML = t; }

  function celebrate(btn, img) {
    style();
    var from = btn;
    if (btn && !btn.dataset.tvpAtcBusy) {
      btn.dataset.tvpAtcBusy = '1';
      var before = getText(btn);
      btn.classList.remove('tvp-atc-error');
      btn.classList.add('tvp-atc-added');
      setText(btn, '&#10003; Added!');
      setTimeout(function () {
        btn.classList.remove('tvp-atc-added');
        setText(btn, before);
        delete btn.dataset.tvpAtcBusy;
      }, RESET_MS);
    }
    fly(img, from);
    refreshCount();
  }

  function fail(btn, msg) {
    style();
    if (!btn) return;
    var before = getText(btn);
    btn.classList.add('tvp-atc-error');
    setText(btn, msg || 'Could not add — try again');
    setTimeout(function () { btn.classList.remove('tvp-atc-error'); setText(btn, before); }, 2500);
  }

  window.tvpAtc = { celebrate: celebrate, fly: fly, refreshCount: refreshCount, fail: fail };

  function submitButton(form, e) {
    return (e && e.submitter) || form.querySelector('[data-add-to-cart]') ||
      form.querySelector('button[name="add"], [type="submit"]');
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM' || form.hasAttribute('data-tvp-atc-skip')) return;
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add(?:[/?#.]|$)/.test(action)) return;
    var fd;
    try { fd = new FormData(form); } catch (err) { return; }
    if (!fd.get('id')) return;                                   // nothing to add; leave it to the page
    var qty = parseInt(fd.get('quantity') || '1', 10);
    if (isNaN(qty) || qty <= 0) return;                          // let the theme show its own message
    var btn = submitButton(form, e);
    if (btn && (btn.disabled || btn.getAttribute('aria-disabled') === 'true' || btn.dataset.tvpAtcBusy)) { e.preventDefault(); return; }

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var img = imageFor(form);
    var mainForm = !form.closest('.v2p-card, .list-view-item, .grid__item, .product-card, .featured-product');
    var sticky = mainForm ? document.getElementById('tvp-sticky-btn') : null;
    if (btn) { btn.setAttribute('aria-busy', 'true'); }
    var busyText = btn ? getText(btn) : '';
    if (btn) setText(btn, 'Adding…');

    fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (btn) { btn.removeAttribute('aria-busy'); setText(btn, busyText); }
        if (!res.ok) { fail(btn, (res.body && res.body.description) ? res.body.description : null); return; }
        celebrate(btn, img);
        if (sticky && sticky !== btn) celebrate(sticky, null);
        try { document.dispatchEvent(new CustomEvent('tvp:cart:added', { detail: res.body })); } catch (err) { }
      })
      .catch(function () { if (btn) { btn.removeAttribute('aria-busy'); setText(btn, busyText); } fail(btn); });
  }, true);
})();
